var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kanban-settings-overlay" }, [
    _c(
      "div",
      { staticClass: "overlay-content" },
      [
        _c("h3", [_vm._v(_vm._s(_vm.$t("settings.title")))]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("modules.kanbanSettings.column")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("modules.kanbanSettings.selectField")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "kanban-field-selector",
            attrs: { placeholder: _vm.$t("settings.selectFieldPlaceholder") },
            model: {
              value: _vm.localSettings.kanbanField,
              callback: function ($$v) {
                _vm.$set(_vm.localSettings, "kanbanField", $$v)
              },
              expression: "localSettings.kanbanField",
            },
          },
          _vm._l(_vm.dropdownFields, function (field) {
            return _c(
              "a-select-option",
              { key: field._id, attrs: { value: field._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(field.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("modules.kanbanSettings.card")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("modules.kanbanSettings.selectFields"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "kanban-card-fields" },
          _vm._l(_vm.fields, function (field) {
            return _c(
              "div",
              { key: field._id, staticClass: "field-checkbox" },
              [
                _c(
                  "a-checkbox",
                  {
                    attrs: {
                      checked:
                        _vm.localSettings.cardFields.indexOf(field._id) !== -1,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.toggleCardField(field._id)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(field.name) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "default" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("modules.kanbanSettings.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
              [_vm._v(_vm._s(_vm.$t("modules.kanbanSettings.save")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }